import React from "react";

const ReportMensalPortais = () => {
  return (
    <section>
    
      <iframe src="https://app.powerbi.com/view?r=eyJrIjoiODZmZjVmMDEtZDQyNi00N2QwLTg0MzQtNTU1NWJmOWQzMjk1IiwidCI6ImYyMzQ4MWYzLTI2ZGItNGZjOC1hNzliLTFiZTk2ZWZjMzg4YyIsImMiOjR9" frameborder="0" allowFullScreen="true"></iframe>
    </section>
  );
};

export default ReportMensalPortais;
